import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Marks a string as trusted HTML so it renders via `[innerHtml]` without Angular stripping it.
 *
 * Only use this for CMS-authored content from a trusted source (e.g. CKEditor HTML) — it bypasses
 * Angular's built-in XSS sanitization. For CMS `styles` JSON use the `CmsStyles` directive instead.
 */
@Pipe({
    name: 'trustHtml',
})
export class TrustHtmlPipe implements PipeTransform {
    private readonly _sanitizer: DomSanitizer = inject(DomSanitizer);

    public transform(value: string | null | undefined): SafeHtml | null {
        if (!value) {
            return null;
        }

        return this._sanitizer.bypassSecurityTrustHtml(value);
    }
}
